import axios from 'axios';
import { errorHandling } from './error-handling.service';

const RequestService = {

  post: async (url, body, headers, timeout) => {
    const config = {
      method: 'post',
      url,
      data: body,
      headers: {
        ...headers
      },
      withCredentials: true,
      ...(timeout && { timeout }) // só adiciona se timeout existir
    }

    return await executeRequest(config);
  },

  put: async (url, body, headers) => {
    const config = {
      method: 'put',
      url,
      data: body,
      headers: {
        ...headers
      }
    }

    return await executeRequest(config);
  },

  get: async (url, headers) => {
    const config = {
      method: 'get',
      url,
      headers: {
        ...headers
      },
      withCredentials: true
    }

    return await executeRequest(config);
  }

};

function executeRequest(config) {
  return new Promise((resolve, reject) => {
    axios(config).then(response => resolve(response), err => {
      errorHandling(err.response);
      reject(err);
    });
  });
}

export default RequestService;